import { render, staticRenderFns } from "./LoginAccount.vue?vue&type=template&id=0519be92&scoped=true&lang=html"
import script from "./LoginAccount.vue?vue&type=script&lang=js"
export * from "./LoginAccount.vue?vue&type=script&lang=js"
import style0 from "./LoginAccount.vue?vue&type=style&index=0&id=0519be92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0519be92",
  null
  
)

export default component.exports